import { clsx } from 'clsx'
import { CSSProperties } from 'react'
import { styles } from 'util/style'
import css from './Spinner.module.scss'

type Props = {
  className?: string
  size?: number
  white?: boolean
}

export const Spinner = (props: Props) => {
  let { size, white } = props
  size = size ?? 24
  const className = clsx(props.className, css.container)
  const style = styles({ '--spinner-width': size.toFixed() + 'px' })
  const classNameSvg = clsx(css.spinner, white && css.white)

  return <div className={className} style={style as CSSProperties}>
    <svg viewBox="0 0 50 50" className={classNameSvg}>
      <circle className={css.ring} cx="25" cy="25" r="22.5" />
      <circle className={css.line} cx="25" cy="25" r="22.5" />
    </svg>
  </div>
}
